import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Customer_Excel_Interface } from 'src/app/Interface/Customer_Excel_Interface';
import { Customer_List_Interface, Empty_Customer_List_Interface } from 'src/app/Interface/Customer_List_Interface';
import { FeildActivity_Interface } from 'src/app/Interface/FeildActivity_Interface';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CustomerService } from 'src/app/Service/Customer/Customer.service';
import { FeildActivityService } from 'src/app/Service/FeildActivity/FeildActivity.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { ProvinceService } from 'src/app/Service/Province/Province.service';


@Component({
  selector: 'app-CutomerComment',
  templateUrl: './CutomerComment.component.html',
  styleUrls: ['./CutomerComment.component.scss']
})
export class CutomerCommentComponent implements OnInit {


  constructor(
    private Customer_Service:CustomerService,
    private Alertify_Service:AlertifyService,
    private province_Service:ProvinceService,
    private Nav_Service:NavService,
    private modalService: BsModalService,
    private FeildActivity_Service:FeildActivityService,
  ) { }

  Token:String=""
  page:number=0;
  Procssing:boolean=false

  StartSearchDate:string=''
  Name:string=''
  EndSearchDate:string=''
  SubmitPeriodDate:string='0'

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.Nav_Service.CheckValidPage(this.Token,1120).subscribe(
      data=>{
        this.Read_Service_Province("")
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )


  }

  DataList_Customer:Array<Customer_List_Interface>=[]
  DataList_Customer_Excel:Array<Customer_Excel_Interface>=[]
  Data_Seleted_Customer:Customer_List_Interface=Empty_Customer_List_Interface()
  Data_View_Customer:Customer_List_Interface=Empty_Customer_List_Interface()

  ReadData_Customer(){
    this.Procssing=true

    this.Customer_Service.GetRecord1(
      this.Token,
      this.ProvinceId,
      this.CityId,
      this.Name,
      '',
      '',
      Number(this.SearchCommentType),
      0,
      0,
      this.FeildActivityId,
      '1400-01-01',
      '1410-01-01',
      false).subscribe(
      data=>{
        this.DataList_Customer=data['model']
        this.DataList_Customer_Excel=data['excel']
        this.Procssing=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }




  Set_Customer_view(item:Customer_List_Interface)
  {
    this.Data_View_Customer=item
  }

  OnBack_Comment_Action_Rest(){
    this.Data_View_Customer=Empty_Customer_List_Interface()
  }


  FeildActivityId:string="0"
  ProvinceId:string="0"
  SearchCommentType:string="0"
  CityId:string="0"


    //#region Province

    DataList_Province:Array<General_Interface>=[]
    DataList_City:Array<General_Interface>=[]

    Read_Service_Province(id:string){
      this.province_Service.GetRecord(id,this.Token).subscribe(
        data=>{
          if(id=="")
          {
            this.DataList_Province=data
            this.ReadData_FeildActivity()
          }
          else{
            this.DataList_City=data
          }
        },error=>{
          localStorage.clear()
          location.reload();

        }
      )
    }

    ProvinceChange(){
      this.CityId="0"
      if(this.ProvinceId=="0")
      {
        this.DataList_City=[]
      }
      else{
        this.Read_Service_Province(this.ProvinceId)
      }
    }


    //#endregion


    DataList_FeildActivity:Array<FeildActivity_Interface>=[]
    ReadData_FeildActivity(){
      this.FeildActivity_Service.GetRecord(this.Token).subscribe(
        data=>{
          this.DataList_FeildActivity=data


        },error=>{
          localStorage.clear()
          location.reload();

        }
      )
    }


  //#region Note Letter

  InProccessing:boolean=false
  modalRef_Note: any;
  Note_Dsc: string = ''
  OpenNoteDialog(template: TemplateRef<any>,item:Customer_List_Interface) {
    this.Data_Seleted_Customer=item
    this.modalRef_Note = this.modalService.show(template);
    this.Note_Dsc = ''
  }

  SubmitNote() {
    if (!this.Note_Dsc) {
      this.Alertify_Service.ErrorMessage("Enter the description.")
    }
    else {
      this.InProccessing = true

      this.Customer_Service.AddComment(this.Note_Dsc,this.Data_Seleted_Customer.id, this.Token).subscribe(
        data => {
          this.Alertify_Service.SuccessMessage("Comment submitted successfully.")
          this.InProccessing = false
          this.Note_Dsc = ''
          this.modalRef_Note.hide()
        },error=>{
          localStorage.clear()
          location.reload();
        }
      )
    }
  }

  //#endregion



}
